<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faComment } from '@fortawesome/pro-regular-svg-icons'

const auth = useAuthStore()
const schoolSelector = useSchoolSelector()
const { params } = useRoute()
const { t } = useI18n()

const supportEmail = 'kontakt@aunivers.no'

const splitSlug = (slug: string | string[]) =>
  slug?.toString().split('_id:')[0].replaceAll('-', ' ')

const subject = computed(() => splitSlug(params.subjectSlug ?? ''))
const topic = computed(() => splitSlug(params.topicSlug ?? ''))
const activeSchool = computed(() => schoolSelector.value.currentActiveOrganization?.name)

const body = computed(() => encodeURIComponent([
  t('feedbackButton.emailIntro'),
  t('feedbackButton.emailContent'),
  `${t('feedbackButton.emailLink')} ${window.location.href}.`,
  `${t('feedbackButton.emailSchool')} ${activeSchool.value}.`,
].join('\n\n\n'),
))

const emailSubject = computed(() => encodeURIComponent([
  'Tilbakemelding',
  'Modus',
  subject.value,
  topic.value,
].filter(Boolean).join(' | '),
))

const mailtoLink = computed(() =>
  `mailto:${supportEmail}?subject=${emailSubject.value}&body=${body.value}`,
)
</script>

<template>
  <CommonButton
    v-if="auth.isTeacher"
    :href="mailtoLink"
  >
    <FontAwesomeIcon :icon="faComment" />
    {{ $t('feedbackButton.text') }}
  </CommonButton>
</template>

<style lang="scss" scoped>
.vgs-button {
  color: inherit;
}
</style>
